import React from "react";
import { getIconForUID } from "components/FormerEditor/utils";
import { COLORS } from "utils/styles";

const EnabledIcon = getIconForUID("checkmark");
const DisabledIcon = getIconForUID("closeCircle");
const DEFAULT_SIZE = 20;

const StatusIcon = ({ status, size = DEFAULT_SIZE }) => {
  return status ? (
    <EnabledIcon size={size} color={COLORS.blue} />
  ) : (
    <DisabledIcon size={size} color={COLORS.deactivated} />
  );
};

export default StatusIcon;
